module.exports = __webpack_public_path__ + "img/D0007.04632e1d.svg";